module.exports = __webpack_public_path__ + "img/20160410_2351.5840c5df.jpg";